import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialsModule } from './../shared/materials/materials.module';
import { SharedModule } from '../shared/shared.module';
import { PartnerHomepageComponent } from './partner-homepage.component';

@NgModule({
  declarations: [PartnerHomepageComponent],
  imports: [CommonModule, MaterialsModule, SharedModule],
  providers: [],
})
export class PartnerHomepageModule {}
